export enum PeriodTypesAction {
  UPDATE_PERIOD_TYPES = "UPDATE_PERIOD_TYPES",
}

export type PeriodType = {
  pos: number;
  name: string;
};

export type PeriodTypeUI = PeriodType & {
  id: string;
  isEditable: boolean;
};

export interface PeriodTypesState {
  teamsById: Record<string, PeriodType[]>;
}

export interface updatePeriodTypesAction {
  type: PeriodTypesAction.UPDATE_PERIOD_TYPES;
  data: Record<string, PeriodType[]>;
}

export type TeamPeriodTypes = {
  teamId: string;
  periodtype: PeriodType[];
};

export type PeriodTypesActions = updatePeriodTypesAction;
